module.exports = __webpack_public_path__ + "img/google_play_logo_ensfarget.4fd7bcd.svg";